import React, { useState } from 'react';
import axios from 'axios';
import { Plus, Trash2, GripVertical, Save } from 'lucide-react';
import { ICON_OPTIONS } from '../../data/themes';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LinksTab = ({ profile, setProfile, showMsg }) => {
  const [links, setLinks] = useState(profile.links || []);
  const [saving, setSaving] = useState(false);

  const addLink = () => {
    if (profile.plan === 'free' && links.length >= 5) { showMsg('Free plan limited to 5 links. Upgrade to Premium!'); return; }
    setLinks([...links, { id: `new-${Date.now()}`, name: '', url: '', icon: 'globe', type: 'link', order: links.length }]);
  };

  const updateLink = (idx, field, value) => { const u = [...links]; u[idx] = { ...u[idx], [field]: value }; setLinks(u); };
  const removeLink = (idx) => setLinks(links.filter((_, i) => i !== idx));

  const saveLinks = async () => {
    setSaving(true);
    try {
      const res = await axios.put(`${API}/profile/links`, { links });
      setProfile(prev => ({ ...prev, links: res.data.links })); showMsg('Links saved');
    } catch (err) { showMsg(err.response?.data?.detail || 'Failed'); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="links-tab">
      <div className="flex items-center justify-between mb-8">
        <h2 className="font-heading text-2xl font-normal text-gray-900">Your Links</h2>
        <span className="text-xs font-semibold text-gray-400">{links.length}{profile.plan === 'free' ? '/5' : ''}</span>
      </div>
      <div className="space-y-3 mb-6">
        {links.map((link, idx) => (
          <div key={link.id} className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl p-3 hover:shadow-sm transition-shadow" data-testid={`link-item-${idx}`}>
            <GripVertical className="w-4 h-4 text-gray-300 flex-shrink-0 cursor-grab" />
            <select value={link.icon} onChange={e => updateLink(idx, 'icon', e.target.value)}
              className="bg-gray-50 border border-gray-200 rounded-lg text-gray-700 px-2 py-2 text-xs outline-none w-28 focus:ring-2 focus:ring-indigo-100">
              {ICON_OPTIONS.map(ic => <option key={ic} value={ic}>{ic}</option>)}
            </select>
            <input value={link.name} onChange={e => updateLink(idx, 'name', e.target.value)} placeholder="Label"
              className="bg-white border border-gray-200 rounded-lg text-gray-900 px-3 py-2 text-sm outline-none flex-1 min-w-0 focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400" />
            <input value={link.url} onChange={e => updateLink(idx, 'url', e.target.value)} placeholder="https://..."
              className="bg-white border border-gray-200 rounded-lg text-gray-900 px-3 py-2 text-sm outline-none flex-[2] min-w-0 focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400" />
            <button onClick={() => removeLink(idx)} className="text-gray-300 hover:text-red-500 flex-shrink-0 transition-colors"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
      <div className="flex gap-3">
        <button onClick={addLink} className="flex items-center gap-2 border border-dashed border-gray-300 text-gray-500 hover:text-indigo-600 hover:border-indigo-300 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors" data-testid="add-link-btn">
          <Plus className="w-4 h-4" /> Add Link
        </button>
        <button onClick={saveLinks} disabled={saving} className="bg-gray-900 text-white px-6 py-2.5 rounded-lg font-semibold text-sm hover:bg-black transition-colors disabled:opacity-50 flex items-center gap-2" data-testid="save-links-btn">
          <Save className="w-4 h-4" /> {saving ? 'Saving...' : 'Save Links'}
        </button>
      </div>
    </div>
  );
};

export default LinksTab;
